export default __webpack_public_path__ + "static/media/gsu.a6bcc192.jpg";